import { useLogin } from '../hooks/useLogin';

/**
 * ログインページのContainer Component
 */
export const LoginContainer: React.FC = () => {
  useLogin();
  return null;
};
